import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createSlots as _createSlots, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "filter-container mt-6" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_3 = { class: "col-span-4" }
const _hoisted_4 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, null, -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "col-span-4"
}
const _hoisted_8 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_9 = {
  key: 1,
  class: "col-span-4"
}
const _hoisted_10 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_11 = {
  key: 2,
  class: "col-span-4"
}
const _hoisted_12 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_13 = {
  key: 3,
  class: "col-span-4"
}
const _hoisted_14 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_15 = { value: 0 }
const _hoisted_16 = { value: 1 }
const _hoisted_17 = {
  key: 4,
  class: "col-span-4"
}
const _hoisted_18 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 5,
  class: "col-span-4"
}
const _hoisted_21 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 6,
  class: "col-span-4"
}
const _hoisted_24 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 7,
  class: "col-span-4"
}
const _hoisted_27 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 8,
  class: "col-span-4 flex items-end"
}
const _hoisted_30 = { class: "inline-flex items-center gap-2" }
const _hoisted_31 = {
  key: 9,
  class: "col-span-4"
}
const _hoisted_32 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_33 = { class: "mt-10 flex flex-wrap gap-2" }
const _hoisted_34 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_35 = { class: "block-title" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["onSubmit"]
const _hoisted_38 = { class: "block text-sm font-medium text-gray-700" }

import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import {
  DownloadIcon,
  SaveIcon,
  SearchIcon,
} from "@heroicons/vue/outline";
import VueTableLite from "vue3-table-lite/ts";
import PublicId from "@/components/common/PublicId.vue";
import { isReportPublicId } from "@/utils/publicId";
import { Button } from "@/components/common";
import Modal from "@/components/common/Modal.vue";
import ReportTemplateModal from "@/components/report/ReportTemplateModal.vue";
import ReportDataService from "@/services/report/ReportDataService";
import { ReportTemplateActions } from "@/store/modules/reportTemplate/actions";
import {
  ReportTemplate,
  SystemReportConfig,
  SystemReportParamConfig,
  SystemReportPreview,
  SystemReportType,
} from "@/types/report/ReportTypes";
import { downloadBlob, XLSX_MIME } from "@/utils/downloadBlob";
import { formatReportParamDate, omitEmptyParams } from "@/utils/reportParams";
import { t } from "@/i18n";
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const toast = useToast();

const systemTypes = ref<SystemReportType[]>([]);
const reportConfig = ref<SystemReportConfig | null>(null);
const selectedType = ref<number | null>(null);
const constructors = ref<Array<{ id: string; name: string }>>([]);
const companies = ref<Array<{ id: string; name: string }>>([]);
const roles = ref<Array<{ id: string; name: string }>>([]);
const processTypes = ref<Array<{ id: string; name: string }>>([]);
const preview = ref<SystemReportPreview | null>(null);
const previewLoading = ref(false);
const exportLoading = ref(false);
const saveModalIsShow = ref(false);
const templateModalIsShow = ref(false);
const templateName = ref("");
const selectedTemplateId = ref<string | null>(null);

const filters = ref({
  name: "",
  timeType: 0,
  startDate: null as Date | null,
  endDate: null as Date | null,
  constructorIds: [] as string[],
  companyIds: [] as string[],
  roleIds: [] as string[],
  processTemplateIds: [] as string[],
  isSigning: false,
  sewsType: null as number | null,
});

const startFilters = computed(() => reportConfig.value?.startFilters ?? []);

const hasFilter = (name: string) => startFilters.value.includes(name);

const reportTypeLabel = (reportType: SystemReportType) =>
  reportType.name || reportType.code || String(reportType.type);

const previewColumns = computed(() =>
  (preview.value?.columns ?? []).map((column) => ({
    label: column,
    field: column,
    width: isReportPublicId(column, preview.value?.rows?.[0]?.[column])
      ? "160px"
      : undefined,
    sortable: false,
  }))
);

const previewRows = computed(() => preview.value?.rows ?? []);

const buildPayload = (): SystemReportParamConfig =>
  omitEmptyParams({
    type: selectedType.value ?? undefined,
    reportType: reportConfig.value?.code,
    name: hasFilter("name") ? filters.value.name : undefined,
    timeType: hasFilter("timeType") ? filters.value.timeType : undefined,
    startDate: formatReportParamDate(filters.value.startDate) ?? undefined,
    endDate: formatReportParamDate(filters.value.endDate) ?? undefined,
    constructorIds: hasFilter("constructorIds")
      ? filters.value.constructorIds
      : undefined,
    category: hasFilter("constructorIds") ? filters.value.constructorIds : undefined,
    companyIds: hasFilter("companyIds") ? filters.value.companyIds : undefined,
    branch: hasFilter("companyIds") ? filters.value.companyIds : undefined,
    roleIds: hasFilter("roleIds") ? filters.value.roleIds : undefined,
    roles: hasFilter("roleIds") ? filters.value.roleIds : undefined,
    processTemplateIds: hasFilter("processTemplateIds")
      ? filters.value.processTemplateIds
      : undefined,
    processType: hasFilter("processTemplateIds")
      ? filters.value.processTemplateIds
      : undefined,
    isSigning: hasFilter("isSigning") ? filters.value.isSigning : undefined,
    sewsType: hasFilter("sewsType") ? filters.value.sewsType : undefined,
  });

const onTypeChange = async () => {
  preview.value = null;
  selectedTemplateId.value = null;

  if (selectedType.value == null) {
    reportConfig.value = null;
    return;
  }

  const response = await ReportDataService.getSystemReportConfig(
    selectedType.value
  );
  reportConfig.value = response.data.data;
};

const loadPreview = async () => {
  if (selectedType.value == null) {
    return;
  }

  previewLoading.value = true;
  try {
    const response = await ReportDataService.previewSystemReport(buildPayload());
    preview.value = response.data.data;
  } catch (error) {
    console.error(error);
    toast.error(t("reports.previewError"));
  } finally {
    previewLoading.value = false;
  }
};

const exportReport = async () => {
  if (selectedType.value == null) {
    return;
  }

  exportLoading.value = true;
  try {
    const response = await ReportDataService.exportSystemReport(buildPayload());
    const filename = `${reportConfig.value?.code ?? "system-report"}.xlsx`;
    downloadBlob(new Blob([response.data], { type: XLSX_MIME }), filename);
    toast.success(t("reports.exportSuccess"));
  } catch (error) {
    console.error(error);
    toast.error(t("reports.exportError"));
  } finally {
    exportLoading.value = false;
  }
};

const saveTemplate = async () => {
  if (!reportConfig.value) {
    return;
  }

  const created = await store.dispatch(ReportTemplateActions.CREATE, {
    name: templateName.value,
    reportType: reportConfig.value.code,
    fieldConfig: {},
    paramConfig: buildPayload(),
  });

  selectedTemplateId.value = created?.id ?? null;
  templateName.value = "";
  saveModalIsShow.value = false;
  toast.success(t("reports.templateSaved"));
};

const applyTemplate = async (data: { value: ReportTemplate }) => {
  const template = data.value;
  selectedTemplateId.value = template.id ?? null;

  const params = template.paramConfig as SystemReportParamConfig;
  selectedType.value = params.type ?? null;

  if (selectedType.value != null) {
    await onTypeChange();
  }

  filters.value.timeType = params.timeType ?? 0;
  filters.value.name = params.name ?? "";
  filters.value.startDate = params.startDate ? new Date(params.startDate) : null;
  filters.value.endDate = params.endDate ? new Date(params.endDate) : null;
  filters.value.constructorIds = params.constructorIds ?? params.category ?? [];
  filters.value.companyIds = params.companyIds ?? params.branch ?? [];
  filters.value.roleIds = params.roleIds ?? params.roles ?? [];
  filters.value.processTemplateIds =
    params.processTemplateIds ?? params.processType ?? [];
  filters.value.isSigning = params.isSigning ?? false;
  filters.value.sewsType = params.sewsType ?? null;

  templateModalIsShow.value = false;
};

const previewFromTemplate = async () => {
  if (!selectedTemplateId.value) {
    return;
  }

  previewLoading.value = true;
  try {
    const response = await ReportDataService.previewSystemReportFromTemplate(
      selectedTemplateId.value
    );
    preview.value = response.data.data;
  } catch (error) {
    console.error(error);
    toast.error(t("reports.previewError"));
  } finally {
    previewLoading.value = false;
  }
};

const exportFromTemplate = async () => {
  if (!selectedTemplateId.value) {
    return;
  }

  exportLoading.value = true;
  try {
    const response = await ReportDataService.exportSystemReportFromTemplate(
      selectedTemplateId.value
    );
    downloadBlob(
      new Blob([response.data], { type: XLSX_MIME }),
      `system-report-${selectedTemplateId.value}.xlsx`
    );
    toast.success(t("reports.exportSuccess"));
  } catch (error) {
    console.error(error);
    toast.error(t("reports.exportError"));
  } finally {
    exportLoading.value = false;
  }
};

onMounted(async () => {
  const [
    typesResponse,
    constructorsResponse,
    companiesResponse,
    rolesResponse,
    processTypesResponse,
  ] =
    await Promise.all([
      ReportDataService.getSystemReportTypes(),
      ReportDataService.getSystemReportCategories(),
      ReportDataService.getSystemReportDirectorates(),
      ReportDataService.getSystemReportRoles(),
      ReportDataService.getSystemReportProcessTypes(),
    ]);

  systemTypes.value = typesResponse.data.data ?? [];
  constructors.value = constructorsResponse.data.data ?? [];
  companies.value = companiesResponse.data.data ?? [];
  roles.value = rolesResponse.data.data ?? [];
  processTypes.value = processTypesResponse.data.data ?? [];
});

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(t)("reports.systemReportType")), 1),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedType).value = $event)),
            class: "block w-full rounded-lg border-gray-300",
            onChange: onTypeChange
          }, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemTypes.value, (reportType) => {
              return (_openBlock(), _createElementBlock("option", {
                key: reportType.type,
                value: reportType.type
              }, _toDisplayString(reportTypeLabel(reportType)), 9, _hoisted_6))
            }), 128))
          ], 544), [
            [_vModelSelect, selectedType.value]
          ])
        ]),
        (hasFilter('name'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t)("reports.name")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.name) = $event)),
                type: "text",
                class: "block w-full rounded-lg border-gray-300"
              }, null, 512), [
                [_vModelText, filters.value.name]
              ])
            ]))
          : _createCommentVNode("", true),
        (hasFilter('startDate'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)("logs.dateFrom")), 1),
              _createVNode(_component_Datepicker, {
                locale: "ru",
                selectText: _unref(t)('logs.apply'),
                cancelText: _unref(t)('logs.cancel'),
                placeholder: _unref(t)('logs.datePlaceholder'),
                enableTimePicker: false,
                modelValue: filters.value.startDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.startDate) = $event)),
                format: "dd/MM/yyyy",
                previewFormat: "dd/MM/yyyy",
                autoApply: true
              }, null, 8, ["selectText", "cancelText", "placeholder", "modelValue"])
            ]))
          : _createCommentVNode("", true),
        (hasFilter('endDate'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(t)("logs.dateTo")), 1),
              _createVNode(_component_Datepicker, {
                locale: "ru",
                selectText: _unref(t)('logs.apply'),
                cancelText: _unref(t)('logs.cancel'),
                placeholder: _unref(t)('logs.datePlaceholder'),
                enableTimePicker: false,
                modelValue: filters.value.endDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.endDate) = $event)),
                format: "dd/MM/yyyy",
                previewFormat: "dd/MM/yyyy",
                autoApply: true
              }, null, 8, ["selectText", "cancelText", "placeholder", "modelValue"])
            ]))
          : _createCommentVNode("", true),
        (hasFilter('timeType'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(t)("reports.timeType")), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.timeType) = $event)),
                class: "block w-full rounded-lg border-gray-300"
              }, [
                _createElementVNode("option", _hoisted_15, _toDisplayString(_unref(t)("reports.timeTypeCreated")), 1),
                _createElementVNode("option", _hoisted_16, _toDisplayString(_unref(t)("reports.timeTypeFinished")), 1)
              ], 512), [
                [_vModelSelect, filters.value.timeType]
              ])
            ]))
          : _createCommentVNode("", true),
        (hasFilter('processTemplateIds'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(t)("reports.processType")), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.processTemplateIds) = $event)),
                multiple: "",
                class: "block w-full rounded-lg border-gray-300 min-h-[120px]"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processTypes.value, (processType) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: processType.id,
                    value: processType.id
                  }, _toDisplayString(processType.name), 9, _hoisted_19))
                }), 128))
              ], 512), [
                [_vModelSelect, filters.value.processTemplateIds]
              ])
            ]))
          : _createCommentVNode("", true),
        (hasFilter('constructorIds'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(t)("reports.documentCategory")), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.constructorIds) = $event)),
                multiple: "",
                class: "block w-full rounded-lg border-gray-300 min-h-[120px]"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(constructors.value, (constructor) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: constructor.id,
                    value: constructor.id
                  }, _toDisplayString(constructor.name), 9, _hoisted_22))
                }), 128))
              ], 512), [
                [_vModelSelect, filters.value.constructorIds]
              ])
            ]))
          : _createCommentVNode("", true),
        (hasFilter('roleIds'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(t)("reports.roles")), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.value.roleIds) = $event)),
                multiple: "",
                class: "block w-full rounded-lg border-gray-300 min-h-[120px]"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (role) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: role.id,
                    value: role.id
                  }, _toDisplayString(role.name), 9, _hoisted_25))
                }), 128))
              ], 512), [
                [_vModelSelect, filters.value.roleIds]
              ])
            ]))
          : _createCommentVNode("", true),
        (hasFilter('companyIds'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(t)("reports.companies")), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.value.companyIds) = $event)),
                multiple: "",
                class: "block w-full rounded-lg border-gray-300 min-h-[120px]"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companies.value, (company) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: company.id,
                    value: company.id
                  }, _toDisplayString(company.name), 9, _hoisted_28))
                }), 128))
              ], 512), [
                [_vModelSelect, filters.value.companyIds]
              ])
            ]))
          : _createCommentVNode("", true),
        (hasFilter('isSigning'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.value.isSigning) = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, filters.value.isSigning]
                ]),
                _createElementVNode("span", null, _toDisplayString(_unref(t)("reports.isSigning")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (hasFilter('sewsType'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(t)("reports.sewsType")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.value.sewsType) = $event)),
                type: "number",
                class: "block w-full rounded-lg border-gray-300"
              }, null, 512), [
                [
                  _vModelText,
                  filters.value.sewsType,
                  void 0,
                  { number: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_unref(Button), {
          onClick: loadPreview,
          class: "flex px-10",
          disabled: previewLoading.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SearchIcon), { class: "button-icon mr-2" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("reports.preview")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(Button), {
          onClick: exportReport,
          class: "flex px-10",
          disabled: exportLoading.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DownloadIcon), { class: "button-icon mr-2" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("reports.excelExport")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(Button), {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (saveModalIsShow.value = true)),
          class: "flex px-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SaveIcon), { class: "button-icon mr-2" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("reports.saveReport")), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (templateModalIsShow.value = true)),
          class: "flex px-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SaveIcon), { class: "button-icon mr-2" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("reports.savedReports")), 1)
          ]),
          _: 1
        }),
        (selectedTemplateId.value)
          ? (_openBlock(), _createBlock(_unref(Button), {
              key: 0,
              onClick: previewFromTemplate,
              class: "flex px-10",
              disabled: previewLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("reports.previewFromTemplate")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (selectedTemplateId.value)
          ? (_openBlock(), _createBlock(_unref(Button), {
              key: 1,
              onClick: exportFromTemplate,
              class: "flex px-10",
              disabled: exportLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("reports.exportFromTemplate")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (preview.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("h2", _hoisted_35, _toDisplayString(preview.value.title), 1),
          _createVNode(_unref(VueTableLite), {
            class: "report-table",
            style: _normalizeStyle({ '--report-columns': preview.value.columns.length }),
            "is-slot-mode": true,
            "is-loading": previewLoading.value,
            columns: _unref(previewColumns),
            rows: _unref(previewRows),
            total: _unref(previewRows).length,
            sortable: false,
            "is-hide-paging": true,
            messages: { noDataAvailable: _unref(t)('common.noData') }
          }, _createSlots({ _: 2 }, [
            _renderList(preview.value.columns, (column) => {
              return {
                name: column,
                fn: _withCtx((data) => [
                  (_unref(isReportPublicId)(column, data.value[column]))
                    ? (_openBlock(), _createBlock(PublicId, {
                        key: 0,
                        value: data.value[column],
                        compact: ""
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(data.value[column]), 1))
                ])
              }
            })
          ]), 1032, ["style", "is-loading", "columns", "rows", "total", "messages"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      title: _unref(t)('reports.saveTemplateTitle'),
      show: saveModalIsShow.value,
      onClose: _cache[14] || (_cache[14] = ($event: any) => (saveModalIsShow.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(saveTemplate, ["prevent"])
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(t)("reports.name")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((templateName).value = $event)),
              type: "text",
              class: "w-full rounded-lg border-gray-300"
            }, null, 512), [
              [_vModelText, templateName.value]
            ])
          ]),
          _createVNode(_unref(Button), {
            class: "flex px-10 mt-4",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("reports.save")), 1)
            ]),
            _: 1
          })
        ], 40, _hoisted_37)
      ]),
      _: 1
    }, 8, ["title", "show"]),
    _createVNode(ReportTemplateModal, {
      show: templateModalIsShow.value,
      "system-only": true,
      onSelect: applyTemplate,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (templateModalIsShow.value = false))
    }, null, 8, ["show"])
  ]))
}
}

})